module.exports = __webpack_public_path__ + "img/download_mobile.75d63a41.png";